var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightPanelCollapse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64645 9.64645C6.45118 9.84171 6.45118 10.1583 6.64645 10.3536L9.82843 13.5355C10.0237 13.7308 10.3403 13.7308 10.5355 13.5355C10.7308 13.3403 10.7308 13.0237 10.5355 12.8284L7.70711 10L10.5355 7.17157C10.7308 6.97631 10.7308 6.65973 10.5355 6.46447C10.3403 6.2692 10.0237 6.2692 9.82843 6.46447L6.64645 9.64645ZM15 9.5H7V10.5H15V9.5Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 1,
    height: 8,
    rx: 0.5,
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightPanelCollapse);
export default ForwardRef;